import * as React from "react";
import { formatDate } from "src/util/formatDate";
import { ITrade } from "src/services/interfaces/trade/ITrade";

export const GeneralInfo = (props: { trade: ITrade }) => (
  <div className="region-container general-info information">
    <span className="subtitle">Informações Gerais</span>
    <div className="region-container">
      {props.trade.specialProject && (
        <div className="row">
          <span className="left description">Projeto Especial:</span>
          <span className="right description">{props.trade.specialProject.name}</span>
        </div>
      )}
      <div className="row">
        <span className="left description">Fase:</span>
        <span className="right description">{props.trade.phase}</span>
      </div>
      <div className="row">
        <span className="left description">Status:</span>
        <span className="right description">{props.trade.status}</span>
      </div>
      <div className="row">
        <span className="left description">Data de Criação:</span>
        <span className="right description">{formatDate(props.trade.createdDate)}</span>
      </div>
      <div className="row">
        <span className="left description">Tipo:</span>
        <span className="right description">{props.trade.precatorio.type?.name}</span>
      </div>
      <div className="row">
        <span className="left description">Tribunal:</span>
        <span className="right description">{props.trade.precatorio?.court?.name}</span>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/GeneralInfo/GeneralInfo.tsx